module.exports = "<p>\n  file-list-uploader works!\n</p>\n"